export default {"src":"/_next/static/media/money_pouch.abe27a98.svg","height":191,"width":202,"blurWidth":0,"blurHeight":0};